import React from 'react';
import AMP from '../../../../../components/Forms/amp';

function TIFAmp() {
  return (
    <AMP
      module="tif"
      view="amp"
      drawerTitle="AMP"
      title="AMP"
    />
  );
};

export default TIFAmp;
